import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import style from '../ProductPrice.module.scss.js';
import { Amount } from './Amount.js';
import { PriceWrap } from './PriceWrap.js';

const PriceDiscount = ({ discountInfo, 
// TODO remove this fix
// eslint-disable-next-line @typescript-eslint/no-unused-vars
highlight, ...otherProps }) => discountInfo ? (jsxs(PriceWrap, { highlight: true, ...otherProps, children: [jsx(Amount, { price: `${discountInfo.amount} ${discountInfo.text}`, className: classNames(style['z-product-price__amount--highlight']) }), ' ', jsx(Amount, { price: discountInfo.price, className: classNames(style['z-product-price__amount--highlight']) })] })) : null;
PriceDiscount.displayName = 'PriceDiscount';

export { PriceDiscount };
//# sourceMappingURL=PriceDiscount.js.map
